export const adminNavItems = [
  {
    title_translation_key: 'settings_top_bar_team_and_unit',
    url: '/dashboard/settings/unit-settings',
  },
  {
    title_translation_key: 'settings_top_bar_unit_info',
    url: '/dashboard/settings/unit-details',
  },
  {
    title_translation_key: 'settings_top_bar_templates',
    url: '/dashboard/jobs/post',
  },
  {
    title_translation_key: 'settings_top_bar_career_site',
    url: '/dashboard/settings/career',
  },
  {
    title_translation_key: 'settings_top_bar_billing',
    url: '/dashboard/settings/billing',
  },
];

export const recruiterNavItems = [
  {
    title_translation_key: 'settings_top_bar_templates',
    url: '/dashboard/jobs/post',
  },
];

export const viewerNavItems = [];
